import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import styled from 'styled-components';
import Loading from '../Utility/Loading';
import ApiWrapper from '../../helpers/api/api-wrapper';

const Wrapper = styled.div`
  padding: 0 1rem;
  @media only screen and (min-width: 700px) {
    padding: 0 3rem;
  }
`;

const Header = styled.h3`
  display: block;
  margin-bottom: 3px;
  color: #000;
  font-family: 'Circular-Std-Book';
  font-size: 0.87rem;
`;

const Text = styled.p`
  font-family: 'Circular-Std-Book';
  font-size: .87rem;
  display: block;
  clear: both;
  margin-bottom: 1rem;
`;

const ButtonDeleteAccount = styled.button`
  background: #fff;
  border: 1px solid #e47f8c;
  color: #e47f8c;
  font-size: 14px;
  padding: 0 26px;
  height: 36px;
  border-radius: 100rem;
  cursor: pointer;
  font-family: 'Circular-Std-Book';
  transition: .3s ease all;
`;

const DeleteAccount = () => {
  const {
    user, isAuthenticated, isLoading, loginWithRedirect, logout,
  } = useAuth0();

  if (isLoading) return <Loading />;

  if (!isLoading && !isAuthenticated) {
    return loginWithRedirect({
      screen_hint: 'login',
      prompt: 'select_account',
    });
  }
  const deleteAccount = async () => {
    if(userId) {
      await ApiWrapper.deleteUser(userId);
      return logout({ returnTo: window.location.origin });
    }
  }

  const { email, sub: userId } = user;

  return (
    <Wrapper>
      <div className="caOverTitle">
        <h6>Solicitud de eliminación de cuenta.</h6>
      </div>
      <div className="caUsr">
        <Header>Usuario: {email}</Header>
      </div>
      <div className="caUsr">
        <Text>Para eliminar tu cuenta y sus datos relacionados, da click en el siguiente botón.</Text>
      </div>
      <div className="caTitle">
        <ButtonDeleteAccount type="button" onClick={() => deleteAccount()}>Eliminar cuenta</ButtonDeleteAccount>
      </div>
    </Wrapper>
  );
};

export default DeleteAccount;
